import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentModels } from '../../../../models/document.models';
import { SubscriptionModels } from '../../../../models/subscription.models';
import { projectLegagyDocumentResponse } from '../projectors/document-projector';
import { SubscriptionProjector } from '../projectors/subscription-projector';
import { SubscriptionApiService } from './api/subscription-api.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private subscriptionApiService: SubscriptionApiService) {}

  getDocument(
    type: DocumentModels.DocumentType,
  ): Observable<DocumentModels.Document> {
    return this.subscriptionApiService
      .getDocument(type)
      .pipe(map(projectLegagyDocumentResponse));
  }

  uploadFragment(
    type: DocumentModels.DocumentType,
    file: File,
  ): Observable<number> {
    return this.subscriptionApiService.uploadFragment(type, file);
  }

  getSubscriptionForm(): Observable<SubscriptionModels.SubscriptionForm> {
    return this.subscriptionApiService
      .getBrokerSubscription()
      .pipe(
        map((res) => SubscriptionProjector.projectSubscriptionResponse(res)),
      );
  }

  saveSubscriptionForm(form: SubscriptionModels.SubscriptionForm) {
    return this.subscriptionApiService.saveBrokerSubscription(
      SubscriptionProjector.projectSaveSubscriptionRequest(form),
    );
  }

  getSubscriptionDocumentInformations(
    agencyId: number,
    docType: DocumentModels.DocumentType,
  ): Observable<SubscriptionModels.SubscriptionDocumentInformation> {
    return this.subscriptionApiService
      .getSubscriptionDocumentInformations(agencyId, docType)
      .pipe(
        map((res) =>
          SubscriptionProjector.projectDocumentInformationResponse(
            res,
            docType,
          ),
        ),
      );
  }

  postSubscriptionDocumentInformations(
    agencyId: number,
    informations: SubscriptionModels.SubscriptionDocumentInformation[],
  ): Observable<DocumentModels.DocumentType[]> {
    const observables = informations
      .filter((inf) => inf.fragments.length > 0)
      .map((docInfo) => {
        return this.subscriptionApiService
          .postSubscriptionDocumentInformations(
            agencyId,
            docInfo.type,
            SubscriptionProjector.projectDocumentInformationRequest(docInfo),
          )
          .pipe(map((_) => docInfo.type));
      });

    return forkJoin(observables);
  }
}
